import type { SearchHighlightTextRes } from '@/api/gen/_model/searchHighlightTextRes';
import { buildSourceBackedHighlightSegments, buildSourceBackedHitTermSegments } from '../utils/buildSourceBackedHighlightSegments';
interface HighlightedSearchTextProps {
  text: string;
  highlightSegments?: readonly SearchHighlightTextRes[];
  hitTerms?: readonly string[];
}
export const HighlightedSearchText = ({
  text,
  highlightSegments,
  hitTerms
}: HighlightedSearchTextProps) => {
  const sourceBackedSegments = hitTerms && hitTerms.length > 0 ? buildSourceBackedHitTermSegments(text, hitTerms) : buildSourceBackedHighlightSegments(text, highlightSegments);
  if (sourceBackedSegments) {
    return sourceBackedSegments.map((segment, index) => {
      if (segment.type !== 'hit') return segment.value;
      return <span key={`${segment.value}-${index}`} className="font-bold text-[#5748f2]">
          {segment.value}
        </span>;
    });
  }
  return text;
};